<template>
    <header-search type="button" class="header-search--btn">
        <slot />
    </header-search>
</template>

<script>
import HeaderSearch from "@/components/publish/styles/headers/header-search.vue";

export default {
    props: {},
    components: {
        HeaderSearch,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
